// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2h8Ol","overflowing":"ReadFullNote_overflowing__184Rt"};